<template>
    <div class="admin-panel">
        <header class="admin-panel__header">
            <div class="admin-panel__logo">
                <svg width="63" height="24" viewBox="0 0 63 24" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M57.031 0h-7.941l-1.41 7.977h10.453l4.586-7.977h-5.688z" fill="#B2D234"/><path d="M7.941 7.977l-1.394 7.993-1.41 7.977h7.958l1.394-7.977 1.41-7.993h-7.958z" fill="#50B748"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.84 7.977l-1.394 7.993-1.41 7.977h7.957l1.394-7.977 1.394-7.993h-7.941z" fill="#7FC241"/><path d="M46.286 15.97l1.394-7.993h-7.941l-1.41 7.993-.438 2.507c-.535 3.028 1.491 5.47 4.489 5.47h12.949l4.587-7.977h-13.63z" fill="#99CA3C"/><path d="M7.941 7.977h-7.941l4.587-7.977h4.765l-1.41 7.977z" fill="#50B748"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.899 7.977h-7.957l1.41-7.977h7.941l-1.394 7.977z" fill="#2CA449"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.84 7.977h-7.941l1.394-7.977h7.957l-1.41 7.977z" fill="#7FC241"/><path d="M31.782 7.977h-7.941l1.41-7.977h7.941l-1.41 7.977z" fill="#50B748"/><path d="M39.739 7.977h-7.958l1.41-7.977h7.941l-1.394 7.977z" fill="#99CA3C"/><path fill-rule="evenodd" clip-rule="evenodd" d="M47.681 7.977h-7.941l.438-2.507c.535-3.012 3.404-5.47 6.418-5.47h2.496l-1.41 7.977z" fill="#7FC241"/></svg>
            </div>
            <div class="admin-panel__tools">
                <div class="btn_back" @click="$router.push('/')">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve">
                        <g>
                            <path d="M932.254,490.726L772.835,331.315c-11.754-11.755-30.775-11.771-42.53-0.094c-11.786,11.684-11.896,30.748-0.267,42.582
                                L836.411,482H408.187c-16.636,0-30.132,13.357-30.132,30s13.497,30,30.132,30H838.2L730.21,650.055
                                c-11.755,11.763-11.755,30.887,0,42.649c5.885,5.885,13.606,8.848,21.312,8.848c7.706,0,15.427-2.933,21.312-8.818l159.419-159.406
                                c5.649-5.65,8.82-13.314,8.82-21.302C941.073,504.039,937.903,496.375,932.254,490.726z"/>
                            <path d="M698.927,787.552c-16.636,0-30,13.489-30,30.132V964h-526V60h526v146.376c0,16.643,13.364,30.132,30,30.132
                                c16.635,0,30-13.489,30-30.132V29.914C728.927,13.27,715.238,0,698.603,0H113.032C96.397,0,82.927,13.27,82.927,29.914v964.233
                                c0,16.643,13.47,29.854,30.106,29.854h585.571c16.635,0,30.324-13.21,30.324-29.854V817.684
                                C728.927,801.041,715.562,787.552,698.927,787.552z"/>
                        </g>
                    </svg>
                </div>
            </div>
        </header>
        <main class="admin-panel__main">
            <nav class="admin-panel__nav hide">
                <ul class="nav__list">
                    <li class="nav__item">
                        <span class="nav__icon">
                            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g data-name="Layer 42" id="Layer_42"><path class="cls-1" d="M2,29a1,1,0,0,1-1-1.11l.77-7a1,1,0,0,1,.29-.59L18.42,3.94a3.2,3.2,0,0,1,4.53,0l3.11,3.11a3.2,3.2,0,0,1,0,4.53L9.71,27.93a1,1,0,0,1-.59.29l-7,.77Zm7-1.78H9ZM3.73,21.45l-.6,5.42,5.42-.6,16.1-16.1a1.2,1.2,0,0,0,0-1.7L21.53,5.35a1.2,1.2,0,0,0-1.7,0Z"/><path class="cls-1" d="M23,14.21a1,1,0,0,1-.71-.29L16.08,7.69A1,1,0,0,1,17.5,6.27l6.23,6.23a1,1,0,0,1,0,1.42A1,1,0,0,1,23,14.21Z"/><rect class="cls-1" height="2" transform="translate(-8.31 14.13) rotate(-45)" width="11.01" x="7.39" y="16.1"/><path class="cls-1" d="M30,29H14a1,1,0,0,1,0-2H30a1,1,0,0,1,0,2Z"/></g></svg>
                        </span>
                        <span class="nav__text">Редактирование данных</span>
                    </li>
                </ul>
            </nav>
            <section class="admin-panel__content">
                <span class="info">Поиск по одному полю</span>
                <div class="search__block">
                    <div class="inp__block">
                        <input type="email" class="search__inp" placeholder="Email" v-model.trim="email">
                        <input type="tel" class="search__inp" v-mask="'+7 (###) ### ## ##'" placeholder="+7 - - - - - - - - - -" v-model.trim="phone">
                        <input type="text" class="search__inp" placeholder="ID клиента" v-model.trim="id_client">
                    </div>
                    <button class="search__btn" @click="submitForm">Поиск</button>
                </div>
                <div class="result__block" :class="{'hide': !loaded}">
                    <admin-edit-profile :person="personalData"></admin-edit-profile>
                </div>
            </section>
        </main>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import AdminEditProfile from '@/components/AdminEditProfile'
export default {
    components: { AdminEditProfile },
    data(){
        return {
            email: '',
            phone: '',
            id_client: '',
            loaded: false
        }
    },
    computed: {
        ...mapGetters({
            personalData: 'admin/personalData'
        }),
    },
    methods: {
        ...mapActions({
            getPersonalData: 'admin/getPersonalData',
            updatePersonalData: 'admin/updatePersonalData'
        }),
        submitForm() {
            if (this.email || this.phone || this.id_client) {
                let userData = {}
                this.email && (userData.email = this.email)
                if (this.phone && this.phone.startsWith("+7") && this.phone.includes("(")){
                    userData.phone = this.phone.replace(/\s+/g, '').replace('(', '').replace(')', '').slice(2);
                }
                this.id_client && (userData.id_client = this.id_client)
                this.getPersonalData(userData)
                    .then(res => {
                        if(res === 200){
                            this.loaded = true
                        }else{
                            toastr.error('Пользователь не найден');
                        }
                    })
            } 
        },
    }
}
</script>
<style scoped>
.admin-panel{
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}
.admin-panel__header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    background-color: #fff;
    -webkit-box-shadow: 0px 5px 10px -8px rgba(34, 60, 80, 0.6);
    -moz-box-shadow: 0px 5px 10px -8px rgba(34, 60, 80, 0.6);
    box-shadow: 0px 5px 10px -8px rgba(34, 60, 80, 0.6);
    padding: 10px;
    z-index: 1;
}
.admin-panel__main{
    display: flex;
}
.admin-panel__nav{
    width: 250px;
    height: calc(100vh - 50px);
    background: linear-gradient(180deg, rgba(41,172,28,1) 1%, rgba(168,253,45,1) 100%);
    overflow: auto;
    color: #fff;
    padding: 10px;
}
.nav__list{
    list-style: none;
    margin: 0;
    padding: 0;
}
.admin-panel__content{
    width: calc(100% - 250px);
    height: calc(100vh - 50px);
    overflow: auto;
    background-color: #f7f7f7;
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    width: 100%;
}
.btn_back{
    width: 25px;
    cursor: pointer;
}
.btn_back:hover svg g path{
    color: red;
}
.nav__item{
    display: flex;
    column-gap: 10px;
    align-items: center;
    cursor: pointer;
}
.nav__icon{
    width: 20px;
    fill: #fff;
}
.admin-panel__content>div{
    width: 100%;
    padding: 10px;
    -webkit-box-shadow: 0px 0px 10px -3px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: 0px 0px 10px -3px rgba(34, 60, 80, 0.2);
    box-shadow: 0px 0px 10px -3px rgba(34, 60, 80, 0.2);
    border-radius: 2px;
    background-color: #fff;
}
.search__block{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}
.result__block{
    display: flex;
    flex-direction: column;
    padding: 10px;
    gap: 10px;
    flex-wrap: wrap;
}
.inp__block{
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}
.search__inp{
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    padding: 5px 10px;
    color: #464646;
}
.search__btn{
    background-color: #149914;
    padding: 5px 20px;
    border-radius: 3px;
    color: #fff;
    transition: all .2s ease-in-out;
}
.search__btn:hover{
    background-color: #0e710e;
}
.hide{
    display: none;
}
@media (max-width: 434px) {
  .search__inp{
    width: 100%;
  }
}
</style>